import * as React from 'react';
import { Col, Media } from 'react-bootstrap';
import InlineTooltip from '../../../../../../components/common/ToolTip';

type StylingProductsProps = {
    products: any;
    onClickProduct: (id: number) => void;
};

export function StylingProducts({ products, onClickProduct }: StylingProductsProps) {
    return products.map((x: any, index: number) => (
        <Col key={x.id + '-' + index} xs={12} sm={6} md={4} lg={3}>
            <Media
                className={
                    'product-box ' +
                    (x.available ? 'styling ' : 'disabled ') +
                    (x.selected ? 'selected ' : ' ') +
                    (x.required ? 'required ' : ' ')
                }
                onMouseUp={() => onClickProduct(x.id)}
            >
                <Media.Left align="middle">
                    <i className="material-icons">style</i>
                </Media.Left>
                <Media.Body>
                    <Col sm={8}>
                        <h5>{x.name} </h5>
                    </Col>
                    {x.priceBrokerFirm !== null ? (
                        <Col sm={4} className="price-broker-firm">
                            <p>
                                {x.priceBrokerFirm.value}
                                {x.currencySign}
                            </p>
                        </Col>
                    ) : (
                        ''
                    )}
                </Media.Body>
                <Media.Right align="middle">
                    <InlineTooltip id={x.id} tooltip={x.extraText} />
                </Media.Right>
            </Media>
        </Col>
    ));
}
